// extracted by mini-css-extract-plugin
module.exports = {"brandStyles":"brands-module--brand-styles--3dEeE"};